<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('department.label')" :columns="6">
        <select v-model="filters.department" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="department in departments" :value="department" :key="department">{{ department }}</option>
        </select>
      </form-group>

      <form-group :label="$t('productType.label')" :columns="6" v-if="productTypes.length">
        <select v-model="filters.productType" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="productType in productTypes" :value="productType" :key="productType">{{ productType }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      departments: [],
      productTypes: [],
      filters: {
        brand: null,
        department: null,
        productType: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      try {
        this.brands = await api.getBrands(this.module.type, this.module.identifier)
      } catch (err) {
        this.brands = []
      }

      try {
        this.departments = await api.netshoes.getDepartments()
      } catch (err) {
        this.departments = []
      }
    },
    watch: {
      async 'filters.department' (value) {
        if (value === null) {
          this.productTypes = []
          return false
        }

        try {
          this.productTypes = await api.netshoes.getProductTypes(value)
        } catch (err) {
          this.productTypes = []
        }
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Netshoes.vue?51d946e6